import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Candidates } from '../../models/candidates.model';
import { UsersService } from '../../services/users.service';
import { FunctionsService } from '../../services/functions.service';
import { HttpService } from '../../services/http.service';
import { CandidatesProfiles } from '../../models/candidatesProfiles.model';
import { CandidatesSkills } from '../../models/candidatesSkills.model';
import { Skills } from '../../models/skills.model';
import { CandidatesCertificates } from 'src/app/models/candidatesCertificates.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-candidat-software',
  templateUrl: './candidat-software.component.html',
  styleUrls: ['./candidat-software.component.scss']
})
export class CandidatSoftwareComponent implements OnInit {
  candidates: Candidates = new Candidates([]);
  certificatIsLoading: boolean = false;
  certificatsForm: FormGroup = new FormGroup({});
  candidatesCertificates: CandidatesCertificates = new CandidatesCertificates({});
  certificatFile: any = null;
  candidateCertificateList: CandidatesCertificates[] = [];
  jobIDToApply: any;
  showBtnToGoApplyJob = false;
  candidatesProfiles: CandidatesProfiles = new CandidatesProfiles({});
  totalFillingRate = 0;
  personalInfoRate = 0;
  profileRate = 0;
  experienceRate = 0;
  trainingRate = 0;
  languageRate = 0;
  skillRate = 0;
  candidateSkillList: CandidatesSkills[] = [];
  skillList: Skills[] = [];
  skillIsLoading: boolean = false;
  skillsForm: FormGroup = new FormGroup({});

  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService) {


    if (usersService.getUserType() != 'candidat') {
      this.router.navigate(['/not-found']);
    }

    this.candidates = this.usersService.getCurrentUser();

    if (localStorage.getItem('jobIDToApply') && localStorage.getItem('jobIDToApply') != undefined) {
      this.jobIDToApply = localStorage.getItem("jobIDToApply");

      this.showBtnToGoApplyJob = true;
    }
  }

  ngOnInit(): void {
    this.calculateTotalFillingRate();
    this.initSkillForm();
  }

  getCandidateSkills() {
    const candidateSkills: any = this.candidates.getCandidatesSkills();

    this.candidateSkillList = [];

    candidateSkills.forEach((element: any) => {
      let candidatesSkills = new CandidatesSkills(element);
      this.candidateSkillList.push(candidatesSkills);
    });
    return this.candidateSkillList;
  }
  calculateTotalFillingRate() {

    if (this.candidates.getGender() !== null && this.candidates.getGender() !== '') {
      this.personalInfoRate = 20;
    } else {
      this.personalInfoRate = 0;
    }

    if (this.candidatesProfiles.getProfessions() && this.candidatesProfiles.getProfessions().getLibelle() != undefined) {
      this.profileRate = 20;
    } else {
      this.profileRate = 0;
    }

    if (this.candidates.getCandidatesTrainings().length > 0) {
      this.trainingRate = 15;
    } else {
      this.trainingRate = 0;
    }

    if (this.candidates.getCandidatesLanguages().length > 0) {
      this.languageRate = 15;
    } else {
      this.languageRate = 0;
    }

    if (this.candidates.getCandidatesSkills().length > 0) {
      this.skillRate = 15;
    } else {
      this.skillRate = 0;
    }

    if (this.candidates.getCandidatesExperiences().length > 0) {
      this.experienceRate = 15;
    } else {
      this.experienceRate = 0;
    }

    this.totalFillingRate = this.personalInfoRate + this.profileRate + this.experienceRate + this.trainingRate + this.languageRate + this.skillRate;

    localStorage.setItem('totalFillingRate', JSON.stringify(this.totalFillingRate));
  }

  initSkillForm() {
    this.calculateTotalFillingRate();
    this.getCandidateSkills();
    this.skillList = this.functionsService.getSkillsList();
    this.skillsForm = this.formBuilder.group({
      skill_id: ['', Validators.required],
      level: ['', Validators.required],
    });
  }

  onSubmitSkillForm(): any {
    let formValue: any = this.skillsForm.value;

    this.skillIsLoading = true;

    this.httpService.addCandidateSkill(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.skillIsLoading = false;
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Logiciel ajouté.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initSkillForm();
          this.getCandidateSkills();
        }
      },
      (error) => {
        this.skillIsLoading = false;
        if (error.error.message == 'CANDIDATE_SKILL_ALREADY_EXIST') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ce logiciel a déjà été ajouté.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      }
    );
  }

  removeSkill(id: number) {
    Swal.fire({
      title: 'Souhaitez vous supprimer ce logiciel ?',
      showDenyButton: true,
      confirmButtonText: 'Oui',
      denyButtonText: `Non`,
      confirmButtonColor: '#28a745',
      denyButtonColor: 'dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Veuillez patientez...');
        this.httpService.removeCandidateSkill(id, this.candidates.getToken()).subscribe(
          (response: any) => {
            if (response.status == "success") {
              let data = response.data;
              localStorage.setItem('currentCandidate', JSON.stringify(data));
              Swal.fire({
                icon: 'success',
                title: 'Excellent !',
                text: 'Logiciel supprimé.',
              });
              this.candidates = this.usersService.getCurrentUser();
              this.initSkillForm();
              this.getCandidateSkills();
            }
          },
          (error) => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        );
      }
    })
  }

}
